import Modal from 'flarum/common/components/Modal';
const dayjs = window.dayjs;
export default class PlayerStatsModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.player = this.attrs.player;
    this.globalStats = this.attrs.globalStats || {};
    this.matchHistory = this.player.history || [];
  }
  className() {
    return 'PlayerStatsModal Modal--large';
  }
  title() {
    const titleText = app.translator.trans('nagusi-match-ratings.forum.modal.history_title') || 'Historial';
    return this.player && this.player.name ? "".concat(this.player.name, " - ").concat(titleText) : titleText;
  }
  formatDate(dateStr) {
    if (!dateStr) return '';
    try {
      if (window.dayjs) {
        const d = window.dayjs(dateStr);
        if (d.isValid()) {
          return d.format('DD/MM/YYYY');
        }
      }
      const parsed = new Date(dateStr);
      if (!isNaN(parsed.getTime())) {
        const day = String(parsed.getDate()).padStart(2, '0');
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const year = parsed.getFullYear();
        return "".concat(day, "/").concat(month, "/").concat(year);
      }
      return dateStr;
    } catch (e) {
      return dateStr;
    }
  }
  content() {
    const entityType = this.player.entityType || 'player';
    const isPlayer = entityType === 'player';
    const M = parseFloat(this.globalStats.M) || 0;
    const C = parseFloat(this.globalStats.C) || 5;
    const N = parseInt(this.player.matchCount, 10) || 0;
    const P = parseFloat(this.player.average) || 0;
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Player-Modal-Header"
    }, m("div", {
      className: "Player-Profile"
    }, this.player.photoUrl ? m("img", {
      src: this.player.photoUrl,
      alt: "",
      className: "Player-Avatar-Large"
    }) : m("div", {
      className: "Player-Avatar-Large-Placeholder"
    }, this.player.name.substring(0, 1)), m("div", {
      className: "Player-Info"
    }, m("h2", null, this.player.name), m("span", {
      className: "entity-tag"
    }, app.translator.trans("nagusi-match-ratings.forum.stats.".concat(entityType))))), m("div", {
      className: "Player-Main-Stats"
    }, m("div", {
      className: "Stat-Box"
    }, m("span", {
      className: "label"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.average'), ":"), m("span", {
      className: "value"
    }, this.player.average)), m("div", {
      className: "Stat-Box"
    }, m("span", {
      className: "label"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.median'), ":"), m("span", {
      className: "value"
    }, this.player.median)), isPlayer && m("div", {
      className: "Stat-Box Highlight"
    }, m("span", {
      className: "label"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.aa_score'), ":"), m("span", {
      className: "value"
    }, this.player.aaScore)))), isPlayer && m("div", {
      className: "Calculation-Explainer"
    }, m("h3", null, app.translator.trans('nagusi-match-ratings.forum.modal.how_calculated')), m("div", {
      className: "Formula-Section"
    }, m("div", {
      className: "Formula-Display"
    }, m("span", {
      className: "formula"
    }, "(N \xD7 P + C \xD7 M) / (N + C)")), m("div", {
      className: "Formula-Params"
    }, m("div", {
      className: "Param"
    }, m("span", {
      className: "key"
    }, "N"), m("span", {
      className: "desc"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.param_n'), ":"), m("span", {
      className: "val"
    }, N)), m("div", {
      className: "Param"
    }, m("span", {
      className: "key"
    }, "P"), m("span", {
      className: "desc"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.param_p'), ":"), m("span", {
      className: "val"
    }, P.toFixed(2))), m("div", {
      className: "Param"
    }, m("span", {
      className: "key"
    }, "C"), m("span", {
      className: "desc"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.param_c'), ":"), m("span", {
      className: "val"
    }, C)), m("div", {
      className: "Param"
    }, m("span", {
      className: "key"
    }, "M"), m("span", {
      className: "desc"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.param_m'), ":"), m("span", {
      className: "val"
    }, M.toFixed(2)))), m("div", {
      className: "Calculation-Step"
    }, m("i", {
      className: "fas fa-arrow-right"
    }), m("span", null, "(", N, " \xD7 ", P.toFixed(2), " + ", C, " \xD7 ", M.toFixed(2), ") / (", N, " + ", C, ") = ", m("strong", null, this.player.aaScore))))), m("div", {
      className: "Match-History-Section"
    }, m("h3", null, app.translator.trans('nagusi-match-ratings.forum.modal.history_title')), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, app.translator.trans('nagusi-match-ratings.forum.modal.opponent')), m("th", null, app.translator.trans('nagusi-match-ratings.forum.modal.date')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.avg_label')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.med_label')))), m("tbody", null, this.matchHistory.length > 0 ? this.matchHistory.map(item => m("tr", null, m("td", null, item.opponent), m("td", null, this.formatDate(item.date)), m("td", {
      className: "center bold"
    }, item.mean), m("td", {
      className: "center"
    }, item.median))) : m("tr", null, m("td", {
      colspan: "4",
      className: "center",
      style: {
        padding: '25px',
        color: 'var(--muted-color)'
      }
    }, app.translator.trans('nagusi-match-ratings.forum.stats.no_votes'))))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/PlayerStatsModal', PlayerStatsModal);